<template>
  <vx-card class="" title="">
    <div id="vx-loading"></div>
    <vs-row vs-type="flex" vs-justify="center" class="mt-8">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center"> </vs-col>
    </vs-row>
    <div class="mt-5">
      <form-wizard
        color="#197CBF"
        :title="null"
        :subtitle="null"
        backButtonText="Atras"
        nextButtonText="Siguiente"
        finishButtonText="Inscribirme"
      >
        <!-- registro -->
        <tab-content
          title="Registro"
          class="mb-5 mt-2"
          icon="feather icon-user-check"
          :before-change="() => validateStep('step1')"
        >
          <first-step
            ref="step1"
            :stateOptions="stateOptions"
            @requestPackages="requestPackages"
            @on-validated="onStepValidated"
          />
          <!-- --- -->
        </tab-content>

        <!-- tab 2 content -->
        <!-- detalles -->
        <tab-content
          title="Membresia"
          class="mb-5 mt-2"
          icon="feather icon-edit-1"
          :before-change="() => validateStep('step2')"
        >
          <second-step
            ref="step2"
            @on-validated="onStepValidated"
            :locationPackages="locationPackages"
            :locationName="locationName"
          />
        </tab-content>

        <!-- tab 3 content -->
        <!-- pago -->
        <tab-content
          title="Pago"
          class="mb-5 mt-2"
          icon="feather icon-credit-card"
          :before-change="() => validateStep('step3')"
        >
          <third-step
            ref="step3"
            :stateOptions="stateOptions"
            :totalPrice="totalPrice"
            :locationApiKey="locationApiKey"
            :locationMid="locationMid"
            :locationTid="locationTid"
            :creditCard="creditCard"
            :banks="banks"
            :packagePeriodicity="wizardModel.paquete_details.periodicity"
            @on-validated="onStepValidated"
            @on-save-card="onSaveCard"
          />
        </tab-content>

        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <wizard-button
              v-if="props.activeTabIndex > 0"
              @click.native="prevTab(props)"
              :style="props.fillButtonStyle"
            >
              Atras
            </wizard-button>
          </div>
          <div class="wizard-footer-right">
            <wizard-button
              v-if="!props.isLastStep"
              @click.native="nextTab(props)"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
              :disabled="disabledNextButton"
            >
              Siguiente
            </wizard-button>

            <wizard-button
              v-if="props.isLastStep"
              @click.native="submitWizard()"
              id="button-with-loading"
              color="197CBF"
              class="wizard-footer-right finish-button vs-con-loading__container"
              type="relief"
              :style="props.fillButtonStyle"
              :disabled="disableButtonToFinish"
            >
              Inscribirme
            </wizard-button>
          </div>
          <span
            v-if="props.isLastStep && disableButtonToFinish"
            class="block text-center mt-4"
          >
            Debe guardar su tarjeta para inscribirse.</span
          >
        </template>
      </form-wizard>
    </div>
  </vx-card>
</template>

<script>
// --- Imports ---
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import FirstStep from "@/views/forms/form-wizard/form-wizard-register/FirstStep.vue";
import SecondStep from "@/views/forms/form-wizard/form-wizard-register/SecondStep.vue";
import ThirdStep from "@/views/forms/form-wizard/form-wizard-register/ThirdStep.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "axios";
import moment from "moment-timezone";
import guatemalaCityStateConstant from "@/constants/guatemalaCityState.constant";
import { nextTick } from "vue";
export default {
  data() {
    return {
      stateOptions: guatemalaCityStateConstant,

      disabledNextButton: false,
      locationPackages: [],
      totalPrice: 0,
      wizardModel: {
        paquete_details: {
          paquete_id: "",
          fecha_inicio: "",
          total: "",
          periodicity: "",
        },
      },
      locationName: "",
      creditCard: false,
      locationApiKey: "",
      locationMid: "",
      locationTid: "",
      banks: [],

      savedCard: false,
    };
  },
  computed: {
    disableButtonToFinish() {
      if (this.wizardModel.paquete_details.periodicity == 1) {
        return !this.savedCard;
      }
      if (this.wizardModel.paquete_details.periodicity == 4) {
        return false;
      }
      return true;
    },
  },
  methods: {
    onSaveCard() {
      this.savedCard = true;
    },
    prevTab(props) {
      props.prevTab();
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    nextTab(props) {
      props.nextTab();
    },
    // Form steps validation
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    submitWizard() {
      this.validateStep("step3");
    },

    onStepValidated(model) {
      this.wizardModel = { ...this.wizardModel, ...model };
      if (this.wizardModel.finish) {
        this.wizardComplete();
      }
    },
    wizardComplete() {
      this.$vs.loading({
        background: "#197CBF",
        color: "#FFFFFF",
        container: "#button-with-loading",
        scale: 0.6,
      });

      const data = {
        ...this.wizardModel.customer_details,
        card_details: this.wizardModel.card_details,
        paquete_details: this.wizardModel.paquete_details,
        invoice_details: this.wizardModel.invoice_details,
      };

      axios
        .post(`${process.env.VUE_APP_API_URL}/api/1.1/wf/new-member`, data, {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_TOKEN}`,
          },
        })
        .then((response) => {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");

          if (response.data.response.status == true) {
            // window.location.href = `/success?URL=${btoa(
            //   response.data.response.credentials_url
            // )}`;
            this.$router.push({
              name: "success",
              query: { URL: btoa(response.data.response.credentials_url) },
            });
          } else {
            // window.location.href = `/error?MESSAGE=${btoa(
            //   response.data.response.message
            // )}`;
            this.$router.push({
              name: "error",
              query: { MESSAGE: btoa(response.data.response.message) },
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          // window.location.href = `/error?MESSAGE=${btoa(
          //   "Error al procesar la transaccion."
          // )}`;
        });
    },
    requestPackages(
      disabledNextButton,
      locationPackages,
      locationName,
      locationApiKey,
      locationCode,
      locationTid,
      locationMid
    ) {
      this.locationName = locationName;
      this.locationApiKey = locationApiKey;
      this.locationMid = locationMid;
      this.locationTid = locationTid;
      this.disabledNextButton = disabledNextButton;
      this.locationPackages = locationPackages.map((locationPackage) => {
        // Quita las diagonales invertidas del string
        const jsonStringSinDiagonales = locationPackage.online_enrollments
          .replace(/\\/g, "")
          .replace(/'/g, "");

        // Agrega corchetes para convertir el string en un arreglo de objetos
        const jsonArray = `[${jsonStringSinDiagonales}]`;

        // Parsea el JSON
        const registerArray = JSON.parse(jsonArray);

        //obtener amount para la inscripcion buscando en registerArray el objeto que tenga la propiedad center igual a locationCode

        let registerAmountBasedOnCenter = 0;
        const registerArrayFilterByLocationCode = registerArray.find(
          (register) => register.center == locationCode
        );

        if (
          registerArrayFilterByLocationCode &&
          Object.keys(registerArrayFilterByLocationCode).length > 0
        ) {
          registerAmountBasedOnCenter =
            registerArrayFilterByLocationCode.amount;
        }

        const periodicity = locationPackage.periodicity
          ? locationPackage.periodicity
          : 1;

        const total = this.getTotal(
          locationPackage.precio,
          registerAmountBasedOnCenter,
          locationPackage.cobro_inscripcion,
          periodicity
        );

        const packagePriceCurrentMonth = this.packagePriceCurrentMonth(
          locationPackage.precio,
          periodicity
        );

        return {
          _id: locationPackage._id,
          nombre: locationPackage.nombre,
          precio: locationPackage.precio,
          cobro_inscripcion: locationPackage.cobro_inscripcion,
          inscripcion: registerAmountBasedOnCenter,
          periodicity,
          active: false,
          total,
          packagePriceCurrentMonth,
        };
      });
    },
    getTotal(price, registerPrice, payRegister, periodicity) {
      //@params price: precio del paquete [Number]
      //@params registerPrice: precio de la inscripcion [Number]
      //@params payRegister: si se paga inscripcion o no [Boolean]
      //@params periodicity: periodicidad del paquete (1: mensual, 2: anual) [Number]

      const today = moment().tz("America/Guatemala");
      const day = today.date();
      let totalPrice = 0;

      //periodicidad 1 = mensual
      //periodicidad 2 = anual
      if (periodicity == 1) {
        //si el dia esta entre 1 y 8 se paga el 100%
        if (day >= 0 && day <= 8) {
          totalPrice = payRegister
            ? Math.ceil((price * 100) / 100) + registerPrice
            : Math.ceil((price * 100) / 100);
        } else if (day >= 9 && day <= 16) {
          //si el dia esta entre 9 y 16 se paga el 75%
          totalPrice = payRegister
            ? Math.ceil((price * 75) / 100) + registerPrice
            : Math.ceil((price * 75) / 100);
        } else if (day >= 17 && day <= 23) {
          //si el dia esta entre 17 y 23 se paga el 50%
          totalPrice = payRegister
            ? Math.ceil((price * 50) / 100) + registerPrice
            : Math.ceil((price * 50) / 100);
        } else if (day >= 24 && day <= 27) {
          //si el dia esta entre 24 y 27 se paga el 25%
          totalPrice = payRegister
            ? Math.ceil((price * 25) / 100) + registerPrice
            : Math.ceil((price * 25) / 100);
        } else if (day >= 28 && day <= 31) {
          //si el dia esta entre 28 y 31 se paga el 10%
          totalPrice = payRegister
            ? Math.ceil((price * 10) / 100) + registerPrice
            : Math.ceil((price * 10) / 100);
        }
      } else {
        //si es anual se paga el 100%
        totalPrice = payRegister ? price + registerPrice : price;
      }

      return Number(totalPrice);
    },
    packagePriceCurrentMonth(price, periodicity) {
      //@params price: precio del paquete [Number]

      //@params periodicity: periodicidad del paquete (1: mensual, 4: anual) [Number]

      const today = moment().tz("America/Guatemala");
      const day = today.date();
      let totalPrice = 0;

      //periodicidad 1 = mensual
      //periodicidad 2 = anual
      if (periodicity == 1) {
        //si el dia esta entre 1 y 8 se paga el 100%
        if (day >= 0 && day <= 8) {
          totalPrice = Math.ceil((price * 100) / 100);
        } else if (day >= 9 && day <= 16) {
          //si el dia esta entre 9 y 16 se paga el 75%
          totalPrice = Math.ceil((price * 75) / 100);
        } else if (day >= 17 && day <= 23) {
          //si el dia esta entre 17 y 23 se paga el 50%
          totalPrice = Math.ceil((price * 50) / 100);
        } else if (day >= 24 && day <= 27) {
          //si el dia esta entre 24 y 27 se paga el 25%
          totalPrice = Math.ceil((price * 25) / 100);
        } else if (day >= 28 && day <= 31) {
          //si el dia esta entre 28 y 31 se paga el 10%
          totalPrice = Math.ceil((price * 10) / 100);
        }
      } else {
        //si es anual se paga el 100%
        totalPrice = price;
      }

      return Number(totalPrice);
    },
  },
  mounted() {
    axios
      .post(
        `${process.env.VUE_APP_API_URL}/api/1.1/wf/get-bancos`,
        {},
        {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_TOKEN}`,
          },
        }
      )
      .then((response) => {
        this.banks = response.data.response.bancos;
      })
      .catch(() => {
        this.banks = [];
      });
  },
  components: {
    FormWizard,
    WizardButton,
    TabContent,
    FirstStep,
    SecondStep,
    ThirdStep,
  },
  watch: {
    async locationApiKey(newVal, oldVal) {
      if (this.locationApiKey) {
        if (newVal == oldVal) {
          this.creditCard = true;
        } else {
          this.creditCard = false;
          await nextTick();
          this.creditCard = true;
        }
      }
    },
    wizardModel() {
      if (this.wizardModel) {
        if (this.wizardModel.paquete_details) {
          this.totalPrice = this.wizardModel.paquete_details.total;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.fill-row-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  .loading-example {
    width: 120px;
    float: left;
    height: 120px;
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    margin: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.05);
      transform: translate(0, 4px);
    }
    h4 {
      z-index: 40000;
      position: relative;
      text-align: center;
      padding: 10px;
    }
    &.activeLoading {
      opacity: 0 !important;
      transform: scale(0.5);
    }
  }
}
</style>
